import React from 'react';
import { Link } from 'react-router-dom';
import ScientificCalculator from '../components/ScientificCalculator';
import CalculatorCategory from '../components/CalculatorCategory';
import SearchBar from '../components/SearchBar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AdTopBanner, AdInContent, AdBottomBanner } from '../components/AdSense';
import {
  financialCalculators,
  fitnessCalculators,
  mathCalculators,
  otherCalculators,
  categoryImages
} from '../data/mock';
import { List, Calculator } from 'lucide-react';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-4 py-8">
          {/* Top Ad Banner */}
          <AdTopBanner />

          {/* Bold CTA for Percentage Calculator */}
          <Link
            to="/percentage-calculator"
            className="block mb-8 p-6 bg-gradient-to-r from-cyan-600 to-blue-700 rounded-xl hover:from-cyan-500 hover:to-blue-600 transition-all shadow-lg shadow-cyan-500/20 group"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-white/20 rounded-lg">
                  <Calculator className="w-8 h-8 text-white" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-white">Click here to use Percentage Calculator</h2>
                  <p className="text-cyan-100">Calculate percentages instantly - the most popular calculator!</p>
                </div>
              </div>
              <div className="text-white text-3xl group-hover:translate-x-2 transition-transform">→</div>
            </div>
          </Link>

          {/* Calculator and Search Section */}
          <div className="flex flex-col lg:flex-row gap-8 mb-12">
            {/* Scientific Calculator */}
            <div className="lg:w-auto">
              <ScientificCalculator />
            </div>
            
            {/* Right Side Content */}
            <div className="flex-1 flex flex-col justify-center">
              {/* Title and Search */}
              <h1 className="text-3xl font-bold text-white mb-2">Free Online Calculators</h1>
              <p className="text-gray-400 mb-6">Quick calculations with powerful scientific features</p>
              <div className="mb-6">
                <SearchBar />
              </div>
              
              {/* Quick Stats */}
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-cyan-400">40+</div>
                  <div className="text-sm text-gray-500">Calculators</div>
                </div>
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-cyan-400">4</div>
                  <div className="text-sm text-gray-500">Categories</div>
                </div>
                <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-cyan-400">Free</div>
                  <div className="text-sm text-gray-500">Forever</div>
                </div>
              </div>
            </div>
          </div>

          {/* In-Content Ad */}
          <AdInContent />

          {/* Calculator Categories Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <CalculatorCategory
              title="Financial Calculators"
              image={categoryImages.financial}
              calculators={financialCalculators}
              categoryPath="/financial-calculators"
            />
            
            <CalculatorCategory
              title="Fitness & Health Calculators"
              image={categoryImages.fitness}
              calculators={fitnessCalculators}
              categoryPath="/fitness-calculators"
            />
            
            <CalculatorCategory
              title="Math Calculators"
              image={categoryImages.math}
              calculators={mathCalculators}
              categoryPath="/math-calculators"
            />
            
            <CalculatorCategory
              title="Other Calculators"
              image={categoryImages.other}
              calculators={otherCalculators}
              categoryPath="/other-calculators"
            />
          </div>

          {/* All Calculators Link */}
          <div className="mt-10 text-center">
            <Link
              to="/sitemap"
              className="inline-flex items-center gap-2 px-8 py-3 bg-[#1a1a1a] hover:bg-[#2a2a2a] text-white rounded-xl transition-all border border-[#2a2a2a] hover:border-cyan-500/50"
            >
              <List className="w-5 h-5 text-cyan-400" />
              View All Calculators
            </Link>
          </div>

          {/* Bottom Ad Banner */}
          <AdBottomBanner />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
